import { render, staticRenderFns } from "./GetUserProfile.vue?vue&type=template&id=5c4296e2&"
import script from "./GetUserProfile.vue?vue&type=script&lang=js&"
export * from "./GetUserProfile.vue?vue&type=script&lang=js&"
import style0 from "./GetUserProfile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports